var Flickity = themeVendor.Flickity,
selectedCellsClass  = '.current-color',
productSliders = document.querySelectorAll('[data-flickity-reinit]'),
sliderParams = [
    {
        cellSelector: selectedCellsClass,
        wrapAround: true,
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: true,
        adaptiveHeight: false,
        pauseAutoPlayOnHover: false,
        selectedAttraction: 0.2,
        friction: 1,
        autoPlay: false,
        on: {
            change: () => {
                var slideId = flickityInstances[0].selectedElement.dataset.id;
                flickityInstances[0].selectCell( `[data-id="${slideId}"]` );
            },
        }
    },
    {
        cellSelector: selectedCellsClass,
        asNavFor: productSliders[0],
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        resize: true,
        on: {
            change: () => {
                var slideId = flickityInstances[1].selectedElement.dataset.id;
                flickityInstances[1].selectCell( `[data-id="${slideId}"]` )
            },
        }
    }
],
flickityInstances = [];

// ensure flickity sliders are loaded and ready before forcing reinit
watchFlickityload = function watchFlickityload() {
    let interval = setInterval(function(){

        if(productSliders && productSliders.length) {
            productSliders.forEach(function(slider,i) {
                if (slider.classList.contains('flickity-enabled'))  {
                    flickityInstances.push(
                        Flickity.data( slider )
                    );
                }
            });
            reinitFlickity();
            clearInterval(interval);
        }

    }, 2000);
}

// reinit flickity only for cells with specific class with "cellSelector" param
reinitFlickity = function reinitFlickity() {

    if(flickityInstances && flickityInstances.length) {
        flickityInstances.forEach(function(slider,i) {
            flickityInstances[i].destroy();
            var targetDataAttribute = productSliders[i].dataset.flickityReinit;
            flickityInstances[i] = new Flickity(`[${targetDataAttribute}]`, sliderParams[i]);
        });
    }
}

